import cs from 'classnames';
import { AztecProduct } from 'types/models';
import { ChoiceDetails } from 'menu/components/MenuModal/ModalComponents';

interface AndedUpsellItemProps {
  andedUpsell: AztecProduct;
  upsellIndex: number;
  handleUpsellItemClick: (upsellIndex: number) => void;
}

export const AndedUpsellItem: React.FC<AndedUpsellItemProps> = ({
  andedUpsell,
  upsellIndex,
  handleUpsellItemClick,
}) => {
  const portionToUse = andedUpsell.portions[andedUpsell.defaultPortionId];
  const displayRecord = andedUpsell.displayRecords[andedUpsell.displayRecordId];
  const isSelected = Boolean(
    portionToUse.quantity && portionToUse.quantity > 0,
  );
  const isInvalid = Boolean(andedUpsell.isInvalid);
  const minimumAge = andedUpsell.minimumCustomerAge;

  const selectorClasses = cs(
    isSelected ? 'checked' : '',
    isInvalid ? 'out-of-stock' : '',
    `choice-selector checkbox`,
  );

  return (
    <div className="choice-row">
      <label
        className={selectorClasses}
        htmlFor={`anded-upsell-${andedUpsell.id}-${upsellIndex}`}
        data-testid="anded-item-choice-checkbox"
      >
        <input
          type="checkbox"
          id={`anded-upsell-${andedUpsell.id}-${upsellIndex}`}
          name={`choiceGroup:${andedUpsell.id}`}
          onChange={() => handleUpsellItemClick(upsellIndex)}
          checked={isSelected}
          aria-checked={isSelected}
          aria-disabled={isInvalid}
          disabled={isInvalid}
        />
        <ChoiceDetails
          choiceDisplayRecord={displayRecord}
          keywords={displayRecord.keywords}
          minimumAge={minimumAge}
          nameOverride={andedUpsell.displayName}
          portion={portionToUse}
          priceToDisplay={portionToUse.price}
        />
      </label>
    </div>
  );
};
